<template>
  <div class="detail-page">
    <div class="noshow"></div>
    <div class="container">
      <title-div
        class="title-content"
        :title="$t('tokens.detail.name')"
        :data="_$route.params.contractHash"
      ></title-div>
      <div class="detail-content">
        <div class="item-content">
          <div class="item double-b">
            <item1-div
              :title="$t('all.name')"
              :singledata="tokenDescription"
              :logo="tokenData.logo"
            >
              <span class="desc-content">
                {{ tokenData.description }}
              </span>
            </item1-div>
          </div>
        </div>
        <!-- <div class="item-content">
          <div class="item">
            <item-div
              :title="$t('all.description')"
              :singledata="tokenData.description"
            ></item-div>
          </div>
        </div> -->
        <div class="content-bar">
          <div class="content-col">
            <div class="content-hd">
              {{ $t("tokens.detail.tokenOverview") }}
              <span>{{ getType(tokenData.type) }}</span>
            </div>
            <!-- <div class="item-content">
              <div class="m-item">
                <item-div
                  :tooltipstr="$t('tooltip.token.price')"
                  :title="$t('tokens.detail.price')"
                  :singledata="`$ ${$HelperTools.toFinancialVal(
                    tokenData.total_supply
                  )}`"
                ></item-div>
              </div>
            </div> -->
            <div class="item-content">
              <div class="m-item">
                <item-div
                  :tooltipstr="$t('tooltip.token.totalSupply')"
                  :title="$t('tokens.detail.totalSupply')"
                  :singledata="tokenTotalSupply"
                ></item-div>
              </div>
            </div>

            <div class="item-content">
              <div class="m-item">
                <item-div
                  :tooltipstr="$t('tooltip.token.volume')"
                  :title="$t('tokens.detail.volume')"
                  :singledata="
                    $HelperTools.toFinancialVal(parseInt(tokenData.ont_sum)) +
                      ' ONT,  ' +
                      $HelperTools.toFinancialVal(tokenData.ong_sum) +
                      ' ONG'
                  "
                ></item-div>
              </div>
            </div>
            <div class="item-content">
              <div class="m-item">
                <item-div
                  :tooltipstr="$t('tooltip.token.addressesamount')"
                  :title="$t('tokens.list.tab.addressCount')"
                  :singledata="$HelperTools.toFinancialVal(holderCount.total)"
                ></item-div>
              </div>
            </div>
            <div class="item-content">
              <div class="m-item">
                <item-div
                  :tooltipstr="$t('tooltip.token.txamount')"
                  :title="$t('tokens.detail.txn')"
                  :singledata="$HelperTools.toFinancialVal(tokenData.tx_count)"
                ></item-div>
              </div>
            </div>
          </div>

          <div class="content-col">
            <div class="content-hd">{{ $t("tokens.detail.tokenProfile") }}</div>
            <div class="item-content">
              <div class="m-item">
                <item-div
                  tooltipstr=""
                  :title="$t('tokens.detail.address')"
                  :address="_$route.params.contractHash"
                  :contract-type="_$route.params.contractType"
                  copyable
                ></item-div>
              </div>
            </div>
            <div class="item-content" v-if="tokenData.contact_info">
              <div class="item">
                <item-div
                  :title="$t('contracts.detail.contact')"
                  :contactdata="JSON.parse(tokenData.contact_info)"
                ></item-div>
              </div>
            </div>
            <div class="item-content" v-if="tokenData.decimals">
              <div class="m-item">
                <item-div
                  :tooltipstr="$t('tooltip.token.decimals')"
                  :title="$t('tokens.detail.decimals')"
                  :singledata="tokenData.decimals"
                ></item-div>
              </div>
            </div>
            <div class="item-content">
              <div class="item">
                <item-div
                  :tooltipstr="$t('tooltip.token.vm_category')"
                  :title="$t('tokens.detail.vm_category')"
                  :singledata="tokenData.vm_category"
                ></item-div>
              </div>
            </div>
            <div class="item-content">
              <div class="m-item">
                <item-div
                  :tooltipstr="$t('tooltip.token.creater')"
                  :title="$t('tokens.detail.creator')"
                  :address="tokenData.creator"
                ></item-div>
              </div>
            </div>

            <div class="item-content">
              <div class="m-item">
                <item-div
                  :tooltipstr="$t('tooltip.token.createdTime')"
                  :title="$t('tokens.detail.createdTime')"
                  :singledata="$HelperTools.getTransDate(tokenData.create_time)"
                ></item-div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="tab-content">
        <div class="tabs">
          <div class="switch">
            <div
              @click="toPage('txns')"
              :class="txnsFlag ? 'btn-current' : 'btn-choose'"
            >
              <div class="text">{{ $t("all.txns") }}</div>
              <div class="line"></div>
            </div>
            <div
              v-if="
                _$route.params.contractType == 'oep8' ||
                  _$route.params.contractType == 'oep5' ||
                  _$route.params.contractType == 'orc721' ||
                  _$route.params.contractType == 'orc1155'
              "
              @click="toPage('tokens')"
              :class="tokensFlag ? 'btn-current' : 'btn-choose'"
            >
              <div class="text">{{ $t("all.tokens") }}</div>
              <div class="line"></div>
            </div>
            <div
              @click="toPage('code')"
              :class="codeFlag ? 'btn-current' : 'btn-choose'"
            >
              <div class="text">{{ $t("tokens.detail.code") }}</div>
              <div class="line"></div>
            </div>
            <div
              @click="toPage('abi')"
              :class="abiFlag ? 'btn-current' : 'btn-choose'"
            >
              <div class="text">{{ $t("tokens.detail.abi") }}</div>
              <div class="line"></div>
            </div>
            <div
              v-if="
                _$route.params.contractType === 'oep4' ||
                  _$route.params.contractType === 'orc20'
              "
              @click="toPage('holder')"
              :class="holderFlag ? 'btn-current' : 'btn-choose'"
            >
              <div class="text">{{ $t("tokens.detail.holder") }}</div>
              <div class="line"></div>
            </div>
            <div
              v-if="
                _$route.params.contractType === 'oep4' ||
                  _$route.params.contractType === 'orc20'
              "
              @click="toPage('analytics')"
              :class="analyticsFlag ? 'btn-current' : 'btn-choose'"
            >
              <div class="text">{{ $t("all.analytics") }}</div>
              <div class="line"></div>
            </div>
          </div>
        </div>
        <div
          v-if="analyticsFlag"
          class="tab-item-wrapper"
          v-loading="fullscreenLoading"
        >
          <div class="tab-item">
            <div class="analytics-container">
              <div class="analytics-tabs">
                <div class="analytics-tab-btn active">
                  {{ $t("analytics.token") }}
                </div>
              </div>
              <div class="analytics-item">
                <tokenanalytics-div
                  :date="AdateList"
                  :amount="TAamountCount"
                  :txCount="TAtxCount"
                  :depositAddressCount="TAdepositAddressCount"
                  :withdrawAddressCount="TAwithdrawAddressCount"
                  :addressCount="TAaddressCount"
                ></tokenanalytics-div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="!analyticsFlag"
          class="tab-item-wrapper"
          v-loading="fullscreenLoading"
        >
          <!-- 交易列表 -->
          <div v-if="txnsFlag" class="tab-item">
            <div class="table-wrapper">
              <table class="table">
                <thead>
                  <tr>
                    <th class="text-first">{{ $t("all.hash") }}</th>
                    <th
                      v-if="_$route.params.contractType === 'oep5'"
                      class="small-th"
                    >
                      {{ $t("tokens.detail.tokenLbl") }}
                    </th>
                    <!-- <th class="small-th"
                        v-if="$route.params.contractType === 'oep5'">{{ $t('tokens.detail.tokenImg') }}</th> -->
                    <th class="small-th">{{ $t("all.status") }}</th>
                    <th class="small-th">{{ $t("all.block") }}</th>
                    <th class="small-th">{{ $t("all.fee") }}</th>
                    <th class="text-right text-last">{{ $t("all.time") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(tx, index) in contractTxList.list" :key="index">
                    <td
                      class="click-able text-first"
                      @click="toTransactionDetailPage(tx.tx_hash)"
                    >
                      {{
                        tx.tx_hash.substr(0, 8) + "..." + tx.tx_hash.substr(56)
                      }}
                    </td>
                    <td v-if="_$route.params.contractType === 'oep5'">
                      {{ tx.hd_name }}
                    </td>
                    <!-- <td v-if="$route.params.contractType === 'oep5' ">
                      <img width="50px"
                           :src="typeof(tx.json_url) === 'undefined' ? '' : tx.hd_image"
                           alt />
                    </td> -->
                    <td :class="tx.confirm_flag === 1 ? 'confirmed' : 'failed'">
                      {{
                        tx.confirm_flag === 1
                          ? $t("transList.confirmed")
                          : $t("transList.failed")
                      }}
                    </td>
                    <td
                      class="click-able"
                      @click="toBlockDetailPage(tx.block_height)"
                    >
                      {{ tx.block_height }}
                    </td>
                    <td>{{ Number(tx.fee).toString() }} ONG</td>
                    <td class="text-right text-last">
                      {{ $HelperTools.getTransDate(tx.tx_time) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <ont-pagination
              v-if="contractTxList.total"
              :total="contractTxList.total"
            ></ont-pagination>
          </div>
          <!-- 资产列表（oep8） -->
          <div
            v-if="
              tokensFlag &&
                (_$route.params.contractType == 'oep8' ||
                  _$route.params.contractType == 'orc1155')
            "
            class="tab-item"
          >
            <div class="table-wrapper">
              <table class="table">
                <thead>
                  <tr>
                    <th class="text-first">{{ $t("all.name") }}</th>
                    <th class="text-right text-last">
                      {{ $t("tokens.detail.totalSupply") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in tokenData.symbol" :key="index">
                    <td class="text-first">{{ item }}</td>
                    <td class="text-right text-last">
                      {{
                        $HelperTools.toFinancialVal(
                          tokenData.total_supply[index]
                        )
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- 资产列表（oep5） -->
          <div
            v-if="
              tokensFlag &&
                (_$route.params.contractType == 'oep5' ||
                  _$route.params.contractType == 'orc721')
            "
            class="tab-item"
          >
            <div class="table-wrapper">
              <table class="table">
                <thead>
                  <tr>
                    <th class="text-first">{{ $t("all.tokenid") }}</th>
                    <th>{{ $t("all.name") }}</th>
                    <th class="text-right text-last">
                      {{ $t("tokens.detail.tokenImg") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in tokenList.list" :key="index">
                    <td class="text-first">{{ item.token_id }}</td>
                    <td>{{ item.name }}</td>
                    <td class="text-right text-last">
                      <img
                        width="50px"
                        :src="typeof item.logo === 'undefined' ? '' : item.logo"
                        alt
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <ont-pagination
              v-if="tokenList.total"
              :total="tokenList.total"
            ></ont-pagination>
          </div>
          <!-- code -->
          <div v-if="codeFlag" class="tab-item">
            <!-- <textarea id="scCodeData" readonly :rows="'6'" v-model="tokenData.code"></textarea> -->
            <!-- <item1-div
              v-if="tokenData.code"
              :jsondata="tokenData.code"
            ></item1-div> -->
            <source-code
              v-for="(code, index) in code_list"
              :key="code"
              :code="code"
              lang="json"
              :show-line-number="false"
              :class="{ 'mt-10': !!index }"
            />
          </div>
          <!-- abi -->
          <div v-if="abiFlag" class="tab-item">
            <!-- <textarea id="scCodeData" readonly :rows="'6'" v-model="tokenData.abi"></textarea> -->
            <!-- <item1-div
              v-if="tokenData.abi"
              :jsondata="JSON.parse(tokenData.abi)"
            ></item1-div> -->
            <source-code
              v-for="(ABI, index) in ABI_list"
              :key="ABI"
              :code="jsonBeautifier(ABI)"
              lang="json"
              :class="{ 'mt-10': !!index }"
            />
          </div>
          <!-- holder -->
          <div v-if="holderFlag" class="tab-item">
            <div class="table-wrapper">
              <table class="table">
                <thead>
                  <tr>
                    <th class="text-first">{{ $t("addressList.rank") }}</th>
                    <th>{{ $t("addressList.name") }}</th>
                    <th class="text-right">{{ $t("addressList.balance") }}</th>
                    <th class="text-right text-last">
                      {{ $t("addressList.percent") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(address, index) in holder.list" :key="index">
                    <td class="text-first">
                      {{ Number(holder.basicRank) + index }}
                    </td>
                    <td
                      class="click-able"
                      @click="toAddressDetailPage(address.addressShow)"
                    >
                      {{ address.addressShow }}
                    </td>
                    <td class="text-right">
                      {{ address.showbalance }}&nbsp;&nbsp;{{ symbol }}
                    </td>
                    <td class="text-right text-last">{{ address.percent }}%</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <ont-pagination
              v-if="holderCount.total"
              :total="holderCount.total"
            ></ont-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Clipboard from "clipboard";
import HelperTool from "./../../helpers/helper";
const BigNumber = require("bignumber.js");
import itemDiv from "../common/DetailItemH";
import item1Div from "../common/DetailItem";
import titleDiv from "../common/DetailTitle";
import analyticsDiv from "../common/addressAnalytics";
import tokenanalyticsDiv from "../common/tokenAnalytics";
import SourceCode from "../contract/SourceCode.vue";
const SEPARATOR = "%&#*";

export default {
  name: "Token-Detail",
  components: {
    itemDiv,
    titleDiv,
    item1Div,
    tokenanalyticsDiv,
    SourceCode
  },
  mounted() {
    this.getTokenData();
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  },
  watch: {
    $route: "getTokenData",
    token: function() {
      this.tokenData = this.token.list;
      this.symbol = this.token.list.symbol;
      if (
        this._$route.params.contractType === "oep4" ||
        this._$route.params.contractType === "orc20"
      ) {
        this.$store.dispatch("GetTokenHolder", this._$route.params).then();
        this.$store.dispatch("GetTokenHolderCount", this._$route.params).then();
      }
    },
    contractTxList: function() {
      this.loadingFlag = true;
      if (this._$route.params.contractType === "oep5") {
        for (var i = 0; i < this.contractTxList.list.length; i++) {
          if (this.contractTxList.list[i].json_url) {
            for (var key in this.$HelperTools.strToJson(
              this.contractTxList.list[i].json_url
            )) {
              if (key == "name") {
                this.contractTxList.list[
                  i
                ].hd_name = this.$HelperTools.strToJson(
                  this.contractTxList.list[i].json_url
                )[key];
              }
              if (key == "image") {
                this.contractTxList.list[
                  i
                ].hd_image = this.$HelperTools.strToJson(
                  this.contractTxList.list[i].json_url
                )[key];
              }
            }
          }
        }
      }
      this.fullscreenLoading = false;
    },
    holder: function() {
      let num = "1";
      for (var j = 0; j < this.tokenData.decimals; j++) {
        num = num + "0";
      }
      num = Number(num);
      if (this.holder.list) {
        for (var i = 0; i < this.holder.list.length; i++) {
          const item = this.holder.list[i];
          if (!item.address.startsWith("0x")) {
            item.addressShow = new Ont.Crypto.Address(item.address).toBase58();
          } else {
            item.addressShow = item.address;
          }
          let x = new BigNumber(item.balance);
          let y = new BigNumber(num);
          item.showbalance = x.dividedBy(y);
          item.percent = new BigNumber(item.percent).multipliedBy(100);
        }
      }
      this.fullscreenLoading = false;
    },
    tokenAnalyticsData: function() {
      let tx = [];
      let amount = [];
      let address = [];
      let withdrawaddress = [];
      let depositaddress = [];
      let dateList = [];
      let recordList = [];
      if (this.tokenAnalyticsData) {
        recordList = this.tokenAnalyticsData;
      } else {
        recordList = [];
      }
      let NowTime = new Date();
      NowTime = NowTime.getTime();
      for (var i = 0; i < recordList.length; i++) {
        let time = recordList[i].date;
        time =
          time.substr(0, 4) + "/" + time.substr(4, 2) + "/" + time.substr(6, 2);
        let date = new Date(time);
        time = date.getTime();
        dateList.push(time);
        tx.push([time, recordList[i].tx_count]);
        amount.push([time, recordList[i].tx_amount]);
        address.push([time, recordList[i].tx_addr]);
        withdrawaddress.push([time, recordList[i].withdraw_addr]);
        depositaddress.push([time, recordList[i].deposit_addr]);
        if (i === recordList.length - 1) {
          console.log(NowTime - dateList[i]);
          if (NowTime - dateList[i] > 86400000) {
            tx.push([NowTime, 0]);
            amount.push([NowTime, 0]);
            address.push([NowTime, 0]);
            withdrawaddress.push([NowTime, 0]);
            depositaddress.push([NowTime, 0]);
          }
        }
      }
      this.TAamountCount = amount;
      this.TAtxCount = tx;
      this.TAdepositAddressCount = depositaddress;
      this.TAwithdrawAddressCount = withdrawaddress;
      this.TAaddressCount = address;
      this.fullscreenLoading = false;
    }
  },
  computed: {
    ...mapState({
      contractTxList: state => state.Contracts.TxList,
      token: state => state.Tokens.Detail,
      holder: state => state.Tokens.Holder,
      holderCount: state => state.Tokens.Count,
      tokenList: state => state.Tokens.TokenList,
      tokenAnalyticsData: state => state.Analytics.tokenAnalytics.info
    }),
    _$route() {
      return {
        params: {
          ...this.$route.params,
          ...this.$route.query
        }
      };
    },
    ABI_list() {
      const abi = this.token.list.abi;
      if (!abi) {
        return [];
      }
      return abi.split(SEPARATOR).filter(item => !!item && item !== "null");
    },
    code_list() {
      const code = this.token.list.code;
      if (!code) {
        return [];
      }
      return code.split(SEPARATOR).filter(item => !!item && item !== "null");
    },
    tokenDescription() {
      const symbol = this.tokenData.symbol;
      if (typeof symbol === "object") {
        return this.tokenData.name;
      }
      return this.tokenData.name + " (" + symbol + ")";
    },
    tokenTotalSupply() {
      const total_supply = this.tokenData.total_supply;

      if (typeof total_supply !== "object") {
        return this.$HelperTools.toFinancialVal(total_supply);
      }
      return this.$HelperTools.toFinancialVal(
        Object.values(total_supply)
          .reduce(
            (accumulator, curr) => accumulator.plus(curr),
            new BigNumber(0)
          )
          .toString()
      );
    }
  },
  data() {
    return {
      showCodeCopied: false,
      showABICopied: false,
      tokenData: {},
      tokenInfo: {},
      loadingFlag: false,
      fullscreenLoading: true,
      txnsFlag: true,
      tokensFlag: false,
      codeFlag: false,
      abiFlag: false,
      holderFlag: false,
      analyticsFlag: false,
      aOntFlag: false,
      aOngFlag: false,
      aoep4Flag: false,
      AontBList: [],
      AongBList: [],
      AdateList: [],
      AtxList: [],
      AdepositList: [],
      AwithdrawList: [],
      TAamountCount: [],
      TAtxCount: [],
      TAdepositAddressCount: [],
      TAwithdrawAddressCount: [],
      TAaddressCount: [],
      symbol: ""
    };
  },
  methods: {
    toPage($val) {
      if ($val == "txns") {
        this.txnsFlag = true;
        this.tokensFlag = false;
        this.codeFlag = false;
        this.abiFlag = false;
        this.analyticsFlag = false;
        this.holderFlag = false;
      }
      if ($val == "tokens") {
        this.txnsFlag = false;
        this.tokensFlag = true;
        this.codeFlag = false;
        this.abiFlag = false;
        this.analyticsFlag = false;
        this.holderFlag = false;
      }
      if ($val == "code") {
        this.txnsFlag = false;
        this.tokensFlag = false;
        this.codeFlag = true;
        this.abiFlag = false;
        this.analyticsFlag = false;
        this.holderFlag = false;
      }
      if ($val == "abi") {
        this.txnsFlag = false;
        this.tokensFlag = false;
        this.codeFlag = false;
        this.abiFlag = true;
        this.analyticsFlag = false;
        this.holderFlag = false;
      }
      if ($val == "holder") {
        this.txnsFlag = false;
        this.tokensFlag = false;
        this.codeFlag = false;
        this.abiFlag = false;
        this.analyticsFlag = false;
        this.holderFlag = true;
      }
      if ($val == "analytics") {
        this.txnsFlag = false;
        this.codeFlag = false;
        this.abiFlag = false;
        this.statisticsFlag = false;
        this.holderFlag = false;
        this.analyticsFlag = true;
        this.getTokenAnalyticsData();
      }
    },
    toTransactionDetailPage($TxnId) {
      if (this._$route.params.net == undefined) {
        this.$router.push({
          name: "TransactionDetail",
          params: { tx_hash: $TxnId }
        });
      } else {
        this.$router.push({
          name: "TransactionDetailTest",
          params: { tx_hash: $TxnId, net: "testnet" }
        });
      }
    },
    toBlockDetailPage($blockHeight) {
      if (this._$route.params.net == undefined) {
        this.$router.push({
          name: "blockDetail",
          params: { param: $blockHeight }
        });
      } else {
        this.$router.push({
          name: "blockDetailTest",
          params: { param: $blockHeight, net: "testnet" }
        });
      }
    },
    toAddressDetailPage($address) {
      if (this._$route.params.net == undefined) {
        this.$router.push({
          name: "AddressDetail",
          params: {
            address: $address,
            assetName: "ALL",
            pageSize: 10,
            pageNumber: 1
          }
        });
      } else {
        this.$router.push({
          name: "AddressDetailTest",
          params: {
            address: $address,
            assetName: "ALL",
            pageSize: 10,
            pageNumber: 1,
            net: "testnet"
          }
        });
      }
    },
    getTokenData() {
      this.token.list = "";
      this.loadingFlag = false;
      this.fullscreenLoading = true;
      this.$store.dispatch("GetToken", this._$route.params).then();
      this.$store.dispatch("GetContractTx", this._$route.params).then();
      this.$store.dispatch("GetTokenList", this._$route.params).then();
    },
    getTokenList() {
      this.fullscreenLoading = true;
      this.$store.dispatch("GetTokenList", this._$route.params).then();
    },
    getTokenAnalyticsData() {
      /*       this.AontBList= []
            this.AongBList= []
            this.AdateList= []
            this.AtxList= []
            this.AdepositList= []
            this.AwithdrawList= []
            this.TAamountCount= []
            this.TAtxCount= []
            this.TAdepositAddressCount= []
            this.TAwithdrawAddressCount= []
            this.TAaddressCount= [] */
      this.fullscreenLoading = true;
      this.$store.dispatch("gettokenAnalytics", this._$route.params).then();
    },
    toTransDetailPage($TxnId) {
      if (this._$route.params.net === "testnet") {
        this.$router.push({
          name: "TransactionDetailTest",
          params: { tx_hash: $TxnId, net: "testnet" }
        });
      } else {
        this.$router.push({
          name: "TransactionDetail",
          params: { tx_hash: $TxnId }
        });
      }
    },
    copyDetailVal($id) {
      let clipboard = new Clipboard(".copy-success");

      clipboard.on("success", function(e) {
        e.clearSelection();
      });

      if ($id === "scCodeData") {
        this.showCodeCopied = true;
      } else {
        this.showABICopied = true;
      }
    },
    toJson(str) {
      return JSON.parse(str);
    },
    getType(type) {
      return (type || "").replace(
        /^([a-z]+)(\d+)$/i,
        (_, m1, m2) => `${m1.toUpperCase()}-${m2}`
      );
    },
    jsonBeautifier(json) {
      try {
        return JSON.stringify(JSON.parse(json), null, 2);
      } catch (error) {
        return json;
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/detail-page.less";
</style>
<style>
.el-loading-spinner .path {
  stroke: #000;
}
</style>

<style lang="less" scoped>
.desc-content {
  margin-left: 50px;
  margin-top: -3px;
  font-size: 14px;
  font-family: Avenir-Book, Avenir;
  color: #000000;
  line-height: 19px;
  flex: 1;
}

.title-content {
  align-self: center;
}

.content-bar {
  display: flex;
  flex-wrap: wrap;
  margin-top: 30px;
}
.content-col {
  width: 540px;
}
.content-hd {
  margin-bottom: 40px;
  font-size: 18px;
  font-family: Avenir-Heavy, Avenir;
  font-weight: 800;
  color: #000000;
  line-height: 25px;

  > span {
    font-size: 12px;
    opacity: 0.6;
    margin-left: 10px;
    font-weight: 300;
  }
}

.mt-10 {
  margin-top: 10px;
}

@media only screen and (max-width: 960px) {
  .content-col {
    flex-basis: 100%;
  }
  .desc-content {
    flex: initial;
    margin-left: 0;
    margin-top: 20px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tokens/Detail.vue